import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Backdrop } from '@mui/material';
import { Oval } from 'react-loader-spinner';

import { useAuthContext } from 'store/context/auth/auth-context';
import { usePatientsContext } from 'store/context/patient-context';
import { useGetPatientShareInfo } from 'modules/report/hooks/usePatientInfo';

const DeepLinking = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useAuthContext();
  const { nativeToken, setNativeToken } = usePatientsContext();
  const { data, isFetching } = useGetPatientShareInfo(nativeToken);

  const { id: userId } = data?.data || {};

  const navigateToReport = (id) => {
    if (id?.length > 0) {
      navigate(`/app/report?patientId=${id}`);
      setNativeToken(null);
    }
  };

  useEffect(() => {
    if (isFetching) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    if (isLoggedIn && userId) {
      navigateToReport(userId);
    }
  }, [nativeToken, isLoggedIn, isFetching]);

  return (
    <>
      {isFetching ? (
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100vh',
            position: 'absolute'
          }}
        >
          <Backdrop
            sx={{
              position: 'fixed',
              zIndex: 1000,
              background: 'rgba(77, 77, 78, 0.84)',
              transition: 'ease-in-out 0.2s !important'
            }}
            open={true}
          />
          <div style={{ zIndex: 1000 }}>
            <br />
            <Oval
              height={60}
              width={60}
              wrapperStyle={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              color="#3CC0C3"
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#FFFFFF"
              strokeWidth={4}
              strokeWidthSecondary={4}
            />
            <br />
            <p style={{ width: '100%', color: '#FFFFFF' }}>
              در حال دریافت اطلاعات بیمار
            </p>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DeepLinking;
